export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20amber%20and%20crimson%20gradient%20background%20with%20soft%20film%20grain%20texture%2C%20subtle%20lens%20flare%20accents%2C%20dark%20silhouette%20of%20audience%20in%20a%20theater%2C%20atmospheric%20lighting%2C%20modern%20minimalist%20cinema%20aesthetic%2C%20warm%20golden%20highlights%20against%20deep%20shadow%2C%20artistic%20composition%2C%20no%20text%2C%20smooth%20gradient%20from%20top%20to%20bottom&width=1800&height=900&seq=hero-cine-2026&orientation=landscape"
          alt="51影视 · 沉浸式追剧体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm text-accent-600 whitespace-nowrap">每日更新 · 热剧不断</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-white leading-tight mb-4">
              51影视<span className="text-accent-400"> · </span>电视剧免费高清在线观看平台
            </h1>

            <p className="text-sm md:text-base text-white/80 leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              汇聚全网最新电视剧大全，热播剧全集免费在线看，高清画质不卡顿、不缓冲。
              每日同步更新各大平台最新剧集，涵盖国产剧、港台剧、日韩剧、欧美剧等全品类内容，
              打造一站式追剧体验，让您随时随地畅享高清观影乐趣。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 text-xs md:text-sm text-white/70">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-check-double-line text-accent-400"></i>
                日更 50+ 剧集
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-hd-line text-accent-400"></i>
                全高清 1080P
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-shield-check-line text-accent-400"></i>
                安全无广告
              </span>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看热播榜单
              </a>
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/15 hover:bg-white/25 text-white rounded-full text-sm font-medium transition-colors border border-white/30 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line"></i>
                浏览专题分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20collage%20of%20drama%20series%20posters%20in%20amber%20and%20crimson%20tones%2C%20stylized%20film%20strip%20edges%2C%20soft%20overlapping%20layers%20of%20stills%20from%20various%20TV%20shows%2C%20modern%20streaming%20platform%20aesthetic%2C%20warm%20lighting%20with%20theatrical%20glow%2C%20artistic%20double%20exposure%20effect%2C%20rich%20textures%2C%20cinematic%20composition&width=900&height=675&seq=hero-visual-2026&orientation=landscape"
                alt="51影视 · 热播剧集精选"
                className="w-full h-full object-cover rounded-xl"
              />
              <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}